import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import React, { PropsWithChildren } from "react";

import { getThemeForBrand } from "src/constants/app/theme";
import { useBrandStore } from "src/stores/brand-store";

export const ThemeProvider = ({ children }: PropsWithChildren) => {
  const brandCode = useBrandStore((state) => state.brandCode);

  const theme = getThemeForBrand({ brandCode });

  return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
};
